import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BenefitsSection } from './components/BenefitsSection';
import { IncludedSection } from './components/IncludedSection';
import { CredibilitySection } from './components/CredibilitySection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { TransformationSection } from './components/TransformationSection';
import { PricingSection } from './components/PricingSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="font-sans text-gray-800 bg-gradient-to-b from-white to-purple-50 min-h-screen" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Header data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <BenefitsSection data-id="element-7" />
        <IncludedSection data-id="element-8" />
        <CredibilitySection data-id="element-9" />
        <TestimonialsSection data-id="element-10" />
        <TransformationSection data-id="element-11" />
        <PricingSection data-id="element-12" />
        <CTASection data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}